import { render, staticRenderFns } from "./ApplicationStatusChip.vue?vue&type=template&id=003d7823&scoped=true&"
import script from "./ApplicationStatusChip.vue?vue&type=script&lang=js&"
export * from "./ApplicationStatusChip.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationStatusChip.vue?vue&type=style&index=0&id=003d7823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d7823",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
